(function ($, Drupal) {

  "use strict";
  Drupal.behaviors.purgeViews = {
    attach: function(context, settings) {
      // Attach only once using once().
      once('purge-views-once', 'body', context).forEach(() => {
        if (localStorage.getItem('purgeViewsReloaded')) {
          return; // Already ran once
        }

      const viewSelectors = [
        '.view-id-listing_search',
        '.view-id-employees',
        '.view-id-news_insights',
        '.view-id-transactions',
        '.view-id-offices',
      ]; // Add all relevant view selectors here
      const emptyViewSelector = viewSelectors.find(selector => {
        const view = document.querySelector(selector);
        if (view) {
          return view && (view.querySelector('.view-empty') || view.children.length === 0);
        }
        return false;
      });

      if (emptyViewSelector) {
        const view = document.querySelector(emptyViewSelector);
        const viewId = view?.className.match(/view-id-([^\s]+)/)?.[1];
        if (viewId) {
          fetch(`/northmarq_listings/purge-views?view_id=${encodeURIComponent(viewId)}`)
            .then(res => res.json())
            .then(data => {
              if (data.status) {
                console.log('View cache purged:', data.status);
                localStorage.setItem('purgeViewsReloaded', '1');
                setTimeout(() => {
                  console.log('Going to reload the page for you now.');
                  window.location.reload();
                }, 5000);
              } else if (data.error) {
                console.warn('View cache purge error:', data.error);
              }
            });
        }
      }
      });
    }
  };


})(jQuery, Drupal);
